import { useState } from 'react'
import { AccountModule } from '@/core/modules/account/account.module'
import LogoutIcon from '@assets/images/logout.svg?react'
import { theme } from '@/core/theme/theme-dark'
import SettingsIcon from '@assets/images/system-settings.svg?react'
import ProfileIcon from '@assets/images/profile.svg?react'
import { useRouting } from '@/core/hooks/useRouting'
import { MenuItem } from '@/ui/components/SimpleMenu/SimpleMenu'
import { UserModule } from '@/core/modules/user/user.module'

export const useHeader = () => {
    const { navigateTo, ROUTES, handleLogout: logout } = useRouting()
    const { isMdrActive } = AccountModule.useStore()

    const handleSettingsClick = () => {
        navigateTo({
            path: ROUTES.settings.path,
            event: {
                name: 'SEM::navigate_to_settings_page',
                params: {
                    origin: 'header_settings',
                },
            },
        })
    }

    const handleLogout = () => logout('header_settings')

    const handleLogoClick = () => {
        navigateTo({
            path: ROUTES.mdr.children.overview.path,
            event: {
                name: 'SEM::navigate_to_mdr_page',
                params: {
                    origin: 'header_logo',
                    isMdrActive,
                },
            },
        })
    }

    const handleBackToMdrClick = () => {
        navigateTo({
            path: ROUTES.mdr.children.overview.path,
            event: {
                name: 'SEM::navigate_to_mdr_page',
                params: {
                    origin: 'settings_back_button',
                    isMdrActive,
                },
            },
        })
    }

    const [open, setOpen] = useState(false)
    const { currentUser } = UserModule.useStore()

    const items: MenuItem[] = [
        {
            id: 'settings-user-email',
            isTitle: true,
            value: currentUser?.email?.value || '',
            addDivider: true,
            leftIcon: (
                <ProfileIcon
                    height={20}
                    width={20}
                    data-testid="system-settings-icon"
                    color={theme.colors.greys[600]}
                />
            ),
        },
        {
            id: 'settings-system-settings',
            value: 'System Settings',
            action: handleSettingsClick,
            addDivider: true,
            leftIcon: (
                <SettingsIcon
                    height={14}
                    width={14}
                    data-testid="system-settings-icon"
                    color={theme.colors.greys[600]}
                />
            ),
        },
        {
            id: 'settings-logout',
            value: 'Log Out',
            action: handleLogout,
            leftIcon: (
                <LogoutIcon
                    height={14}
                    width={14}
                    data-testid="logout-icon"
                    color={theme.colors.greys[600]}
                />
            ),
        },
    ]

    return { items, open, setOpen, handleLogoClick, handleBackToMdrClick }
}
